
import { connect } from 'react-redux';
import Alert from '.';
import { getSuccessMsg, getErrorMsg, getWarningMsg, getInfoMsg } from './selector';
import AlertActions from './action';

const mapStateToProps = state => ({
    success : getSuccessMsg( state ),
    error   : getErrorMsg( state ),
    warning : getWarningMsg( state ),
    info    : getInfoMsg( state )
});

const mapDispatchToProps = dispatch => ({
    removeSuccess : key => dispatch( AlertActions.removeSuccess( key ) ),
    removeError   : key => dispatch( AlertActions.removeError( key ) ),
    removeWarning : key => dispatch( AlertActions.removeWarning( key ) ),
    removeInfo    : key => dispatch( AlertActions.removeInfo( key ) )
});

const AlertContainer = connect(
    mapStateToProps, mapDispatchToProps
)( Alert );

export default AlertContainer;